import React from "react";

import { Skeleton } from "@mui/material";
import { styled } from "@mui/material/styles";

const StyledSkeleton = styled(Skeleton)(({ theme }) => ({
  alignSelf: "center",
  marginLeft: 5,
  marginRight: 5,
  height: 10,
  width: 10,
}));

type StatusEnum = "success" | "warning" | "danger";

export interface StatusCircleProps {
  status: StatusEnum;
}

/**
 * @see Skeleton
 */
export const IgStatusCircle: React.FC<StatusCircleProps> = ({
  status,
}: StatusCircleProps) => {
  return (
    <StyledSkeleton
      variant="circular"
      animation={"pulse"}
      sx={{
        backgroundColor:
          status === "success"
            ? "green"
            : status === "warning"
              ? "orange"
              : "red",
      }}
    />
  );
};
